import {createApp} from 'vue'
import MemberOverlayProfileCard from './MemberOverlayProfileCard'

const el = '.kb-component--member-overlay-profile-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((MemberOverlayProfileCardDOM)=>{
            const component = createApp(MemberOverlayProfileCard).use(Store)
            component.mount(MemberOverlayProfileCardDOM)
        })
    }
}